// extracted by css-extract-rspack-plugin
export default {"cardContent":"CancelDisbursementBatchModal_cardContent__tb4od"};